
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b701584598 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a97649450 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b853926422 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a181209969 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b11573794 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.a581194261 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahat: Tatiller, Ucuz Uçuşlar, Havayolu Şirketi Biletleri ve Uçak Bileti Ücretleri"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b419286653 = messageFormatterFn((function(  ) {
  return function(d) { return "Puanlar uygulandı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1341936474 = messageFormatterFn((function(  ) {
  return function(d) { return "Puanlar kaldırıldı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b246882454 = messageFormatterFn((function(  ) {
  return function(d) { return "İletişim kutusunu kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a802559661 = messageFormatterFn((function(  ) {
  return function(d) { return "Varış noktası"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1327621997 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a375262334 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1378711957 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarih seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1001562069 = messageFormatterFn((function(  ) {
  return function(d) { return "Misafirler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a462936507 = messageFormatterFn((function(  ) {
  return function(d) { return "Ara"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a407695685 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " hakkında daha fazla bilgi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1529606046 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " yeni sekmede açılır, devam etmek için ilk sekmeye dönün"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1142780739 = messageFormatterFn((function(  ) {
  return function(d) { return "Arama sonuçları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1142378418 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen tatil noktası seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a54528884 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen geçerli bir giriş tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1358967755 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatiniz için tarih seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1825306865 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış tarihi, giriş tarihinden sonra olmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a400027449 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış tarihi, giriş tarihinden en fazla 28 gün sonra olmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a194549123 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen geçerli bir çıkış tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a705729649 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen misafir sayısı seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1800440326 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahat eden çocuğun yaşını belirtin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2060916938 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahat eden çocukların yaşını belirtin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1595632616 = messageFormatterFn((function(  ) {
  return function(d) { return "Konaklama tarihleri, seyahat tarihlerine denk gelmelidir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1041126861 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b146559585 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " oda";}, one: function() { return number(d["0"]) + " oda";}, two: function() { return number(d["0"]) + " oda";}, few: function() { return number(d["0"]) + " oda";}, many: function() { return number(d["0"]) + " oda";}, other: function() { return number(d["0"]) + " oda";} }) + ", " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " misafir";}, one: function() { return number(d["1"]) + " misafir";}, two: function() { return number(d["1"]) + " misafir";}, few: function() { return number(d["1"]) + " misafir";}, many: function() { return number(d["1"]) + " misafir";}, other: function() { return number(d["1"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1772041487 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " misafir";}, one: function() { return number(d["1"]) + " misafir";}, two: function() { return number(d["1"]) + " misafir";}, few: function() { return number(d["1"]) + " misafir";}, many: function() { return number(d["1"]) + " misafir";}, other: function() { return number(d["1"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a975120397 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " misafir";}, one: function() { return number(d["1"]) + " misafir";}, two: function() { return number(d["1"]) + " misafir";}, few: function() { return number(d["1"]) + " misafir";}, many: function() { return number(d["1"]) + " misafir";}, other: function() { return number(d["1"]) + " misafir";} }) + ", evcil hayvan"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a845235500 = messageFormatterFn((function(  ) {
  return function(d) { return "Misafirler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1953304992 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " eklendi. Aşağıdan misafir bilgilerini düzenleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b706370112 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda kaldırıldı. Aşağıdan oda " + d["0"] + " misafir bilgilerini düzenleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2018283236 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal edin, Misafir Seçicisi aracını değişiklikleri kaydetmeden kapatın. Dilerseniz aşağıdan misafir bilgilerini düzenleyebilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a725404124 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1579042332 = messageFormatterFn((function(  ) {
  return function(d) { return "Değişiklikleri kaydedin ve Misafir Seçicisi aracını kapatın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1499111560 = messageFormatterFn((function(  ) {
  return function(d) { return "Başka bir oda ekle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1956876761 = messageFormatterFn((function(  ) {
  return function(d) { return "Odayı sil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b897959071 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " odadan " + d["0"] + " tanesini sil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2047482015 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". çocuğun yaşı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a603124231 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a217486950 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " / " + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1542187944 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " yaşındaki " + d["0"] + ". çocuk güncellendi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a406742142 = messageFormatterFn((function(  ) {
  return function(d) { return "1 yaşından küçük"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1779038352 = messageFormatterFn((function(  ) {
  return function(d) { return "Çocuk Sayısı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1023089223 = messageFormatterFn((function(  ) {
  return function(d) { return "(0-17 yaşında)"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1038329786 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " Yetişkin";}, one: function() { return number(d["0"]) + " Yetişkin";}, two: function() { return number(d["0"]) + " Yetişkin";}, few: function() { return number(d["0"]) + " Yetişkin";}, many: function() { return number(d["0"]) + " Yetişkin";}, other: function() { return number(d["0"]) + " Yetişkin";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1821229888 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " Çocuk";}, one: function() { return number(d["0"]) + " Çocuk";}, two: function() { return number(d["0"]) + " Çocuk";}, few: function() { return number(d["0"]) + " Çocuk";}, many: function() { return number(d["0"]) + " Çocuk";}, other: function() { return number(d["0"]) + " Çocuk";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1449839210 = messageFormatterFn((function(  ) {
  return function(d) { return "Yetişkin Sayısı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b670978286 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için çocuk sayısını azaltın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1068278936 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için yetişkin sayısını azaltın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a95239406 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için çocuk sayısını artırın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1554384524 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için yetişkin sayısını artırın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2102756512 = messageFormatterFn((function(  ) {
  return function(d) { return "Evcil hayvan"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b858709764 = messageFormatterFn((function(  ) {
  return function(d) { return "Evcil hayvan dâhil mi?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1474041232 = messageFormatterFn((function(  ) {
  return function(d) { return "Evet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1709043490 = messageFormatterFn((function(  ) {
  return function(d) { return "Hayır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b217326612 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " listelerinize eklendi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1454805018 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni bir pencerede açılır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2146157435 = messageFormatterFn((function(  ) {
  return function(d) { return "Misafir yorumları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a740620003 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal edip otel detaylarına geri dönün."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1516958891 = messageFormatterFn((function(  ) {
  return function(d) { return "Müsaitliği kontrol et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1438882432 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiyatları kontrol et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1847502642 = messageFormatterFn((function(  ) {
  return function(d) { return "Aramayı Değiştir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a128798671 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha geç bir giriş tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1183232043 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha erken bir giriş tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a153042416 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha geç bir çıkış tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1207475788 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha erken bir çıkış tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1160022714 = messageFormatterFn((function(  ) {
  return function(d) { return "Eski fiyat: " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1534944244 = messageFormatterFn((function(  ) {
  return function(d) { return "Fiyat: " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1289377817 = messageFormatterFn((function(  ) {
  return function(d) { return "Şu anki fiyat: " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b132996569 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " olan fiyat artık " + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a166036832 = messageFormatterFn((function(  ) {
  return function(d) { return "gecelik"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a603141968 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal edip otel detaylarına geri dönün."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b155099352 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha çok detay"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b50585038 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapatıp otel detaylarına geri dönün."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1580452444 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sorun oluştu."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a938573974 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni bir arama deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a529799247 = messageFormatterFn((function(  ) {
  return function(d) { return "Bunlar da ilginizi çekebilir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b505466238 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtreleri Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1540625910 = messageFormatterFn((function(  ) {
  return function(d) { return "Sırala ve Filtrele"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a998995476 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1864323607 = messageFormatterFn((function(  ) {
  return function(d) { return "Temizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1247049042 = messageFormatterFn((function(  ) {
  return function(d) { return "Uygula'yı tıklayın veya filtreleri kapatmak için geri gidin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b483522256 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimum fiyat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1362679870 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksimum fiyat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1483650169 = messageFormatterFn((function(  ) {
  return function(d) { return "Yıldız Derecelendirmesi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b761901240 = messageFormatterFn((function(  ) {
  return function(d) { return "Sıralama ölçütü:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a801746519 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtreleme ölçütü:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1896395031 = messageFormatterFn((function(  ) {
  return function(d) { return "Otel aramasına dön"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a672251277 = messageFormatterFn((function(  ) {
  return function(d) { return "Binlerce konaklama yeri aranıyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a758317624 = messageFormatterFn((function(  ) {
  return function(d) { return "Binlerce paket fırsatı aranıyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1979812348 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " filtre";}, one: function() { return number(d["0"]) + " filtre";}, two: function() { return number(d["0"]) + " filtre";}, few: function() { return number(d["0"]) + " filtre";}, many: function() { return number(d["0"]) + " filtre";}, other: function() { return number(d["0"]) + " filtre";} }) + " uygulandı"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1198791292 = messageFormatterFn((function(  ) {
  return function(d) { return "Sırala ve Filtrele"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1594409936 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrele"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b505591267 = messageFormatterFn((function(  ) {
  return function(d) { return "Haritada göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b903499718 = messageFormatterFn((function(  ) {
  return function(d) { return "sonuçlar yükleniyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b688987429 = messageFormatterFn((function(  ) {
  return function(d) { return "sonuçlar güncellendi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a336604203 = messageFormatterFn((function(  ) {
  return function(d) { return "sonuçlar alınırken hata oluştu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1793441577 = messageFormatterFn((function(  ) {
  return function(d) { return "sonuçlar boş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2094125909 = messageFormatterFn((function(  ) {
  return function(d) { return "Otel ara"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1450593828 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1822394703 = messageFormatterFn((function(  ) {
  return function(d) { return "Bunun yerine bu tarihleri deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b862981451 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha fazla tarih göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b900802567 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az tarih göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a44084982 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Otel Arama Sonuçları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1506647127 = messageFormatterFn((function(  ) {
  return function(d) { return "Geçersiz Otel Arama Sonuçları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1225022379 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha Fazla Göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1405391247 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, herhangi bir sonuç bulamadık. Aramanızı ayarlamayı deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b251657305 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçilen filtre"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2095382345 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçilen filtreler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2105286089 = messageFormatterFn((function(  ) {
  return function(d) { return "Tatil noktası eksik"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a244787285 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-" + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b756158347 = messageFormatterFn((function(  ) {
  return function(d) { return "Tüm filtreleri kaldır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1608909364 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " misafir";}, one: function() { return number(d["0"]) + " misafir";}, two: function() { return number(d["0"]) + " misafir";}, few: function() { return number(d["0"]) + " misafir";}, many: function() { return number(d["0"]) + " misafir";}, other: function() { return number(d["0"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a142805964 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, kendi tarafımızda bir sorun yaşıyoruz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b10670937 = messageFormatterFn((function(  ) {
  return function(d) { return "Tekrar deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b86405711 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " konaklama yerini listelerinize kaydedin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1257130535 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " konaklama yerini listelerinizden kaldırın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a243181553 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sonraki konaklamanız için detaylar"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1932946278 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu bölgede ara"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a326530572 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bir sorun oluştu. Lütfen aramanızı tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1157408475 = messageFormatterFn((function(  ) {
  return function(d) { return "Haritayı Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1873487395 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["1"] + " başlangıç fiyatı ile\n" + plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " konaklama yeri";}, one: function() { return number(d["0"]) + " konaklama yeri";}, two: function() { return number(d["0"]) + " konaklama yeri";}, few: function() { return number(d["0"]) + " konaklama yeri";}, many: function() { return number(d["0"]) + " konaklama yeri";}, other: function() { return number(d["0"]) + " konaklama yeri";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a450054458 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " konaklama yeri";}, one: function() { return number(d["0"]) + " konaklama yeri";}, two: function() { return number(d["0"]) + " konaklama yeri";}, few: function() { return number(d["0"]) + " konaklama yeri";}, many: function() { return number(d["0"]) + " konaklama yeri";}, other: function() { return number(d["0"]) + " konaklama yeri";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1587843245 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha fazla göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b862783936 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1082860590 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bizim tarafımızda bir sorun oluştu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2024884450 = messageFormatterFn((function(  ) {
  return function(d) { return "Sonraki Öğe"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1611648418 = messageFormatterFn((function(  ) {
  return function(d) { return "Önceki Öğe"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1420850885 = messageFormatterFn((function(  ) {
  return function(d) { return "Ödeme yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1377178650 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Seyahatiniz (" + plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " oda";}, one: function() { return number(d["0"]) + " oda";}, two: function() { return number(d["0"]) + " oda";}, few: function() { return number(d["0"]) + " oda";}, many: function() { return number(d["0"]) + " oda";}, other: function() { return number(d["0"]) + " oda";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2136881615 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Seyahatiniz (" + plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " konaklama";}, one: function() { return number(d["0"]) + " konaklama";}, two: function() { return number(d["0"]) + " konaklama";}, few: function() { return number(d["0"]) + " konaklama";}, many: function() { return number(d["0"]) + " konaklama";}, other: function() { return number(d["0"]) + " konaklama";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1109354411 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sonraki odanızı seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b406167480 = messageFormatterFn((function(  ) {
  return function(d) { return "Artık müsait değil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b947514196 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatinizdeki bazı konaklama yerleri artık müsait değil. Yine de ödeme sayfasına gitmek istiyor musunuz?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1544377101 = messageFormatterFn((function(  ) {
  return function(d) { return "oda başına"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2005754363 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " misafir";}, one: function() { return number(d["0"]) + " misafir";}, two: function() { return number(d["0"]) + " misafir";}, few: function() { return number(d["0"]) + " misafir";}, many: function() { return number(d["0"]) + " misafir";}, other: function() { return number(d["0"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1355829279 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " oda";}, one: function() { return number(d["0"]) + " oda";}, two: function() { return number(d["0"]) + " oda";}, few: function() { return number(d["0"]) + " oda";}, many: function() { return number(d["0"]) + " oda";}, other: function() { return number(d["0"]) + " oda";} }) + ", " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " misafir";}, one: function() { return number(d["1"]) + " misafir";}, two: function() { return number(d["1"]) + " misafir";}, few: function() { return number(d["1"]) + " misafir";}, many: function() { return number(d["1"]) + " misafir";}, other: function() { return number(d["1"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1140969132 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/gece"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1084337036 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda değiştir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b738893976 = messageFormatterFn((function(  ) {
  return function(d) { return "Kod panoya kopyalandı."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a876661441 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, kendi tarafımızda bir sorun yaşıyoruz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1835536254 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen aramanızı tekrar deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1884993688 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeniden dene"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b430608341 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiralık oto alışı ve dönüşü"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a128245580 = messageFormatterFn((function(  ) {
  return function(d) { return "Alış saati"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b805738592 = messageFormatterFn((function(  ) {
  return function(d) { return "Dönüş saati"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1242208193 = messageFormatterFn((function(  ) {
  return function(d) { return "Kiralık oto"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1712526892 = messageFormatterFn((function(  ) {
  return function(d) { return "Dönüş saati, alış saatinden en az 2 saat sonra olmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a304708440 = messageFormatterFn((function(  ) {
  return function(d) { return "00.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a304797813 = messageFormatterFn((function(  ) {
  return function(d) { return "00.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a305631961 = messageFormatterFn((function(  ) {
  return function(d) { return "01.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a305721334 = messageFormatterFn((function(  ) {
  return function(d) { return "01.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a306555482 = messageFormatterFn((function(  ) {
  return function(d) { return "02.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a306644855 = messageFormatterFn((function(  ) {
  return function(d) { return "02.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a307479003 = messageFormatterFn((function(  ) {
  return function(d) { return "03.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a307568376 = messageFormatterFn((function(  ) {
  return function(d) { return "03.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a308402524 = messageFormatterFn((function(  ) {
  return function(d) { return "04.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a308491897 = messageFormatterFn((function(  ) {
  return function(d) { return "04.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a309326045 = messageFormatterFn((function(  ) {
  return function(d) { return "05.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a309415418 = messageFormatterFn((function(  ) {
  return function(d) { return "05.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a310249566 = messageFormatterFn((function(  ) {
  return function(d) { return "06.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a310338939 = messageFormatterFn((function(  ) {
  return function(d) { return "06.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a311173087 = messageFormatterFn((function(  ) {
  return function(d) { return "07.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a311262460 = messageFormatterFn((function(  ) {
  return function(d) { return "07.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a312096608 = messageFormatterFn((function(  ) {
  return function(d) { return "08.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a312185981 = messageFormatterFn((function(  ) {
  return function(d) { return "08.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a313020129 = messageFormatterFn((function(  ) {
  return function(d) { return "09.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a313109502 = messageFormatterFn((function(  ) {
  return function(d) { return "09.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a333337591 = messageFormatterFn((function(  ) {
  return function(d) { return "10.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a333426964 = messageFormatterFn((function(  ) {
  return function(d) { return "10.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a334261112 = messageFormatterFn((function(  ) {
  return function(d) { return "11.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a334350485 = messageFormatterFn((function(  ) {
  return function(d) { return "11.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a335184633 = messageFormatterFn((function(  ) {
  return function(d) { return "12.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a335274006 = messageFormatterFn((function(  ) {
  return function(d) { return "12.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a336108154 = messageFormatterFn((function(  ) {
  return function(d) { return "13.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a336197527 = messageFormatterFn((function(  ) {
  return function(d) { return "13.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a337031675 = messageFormatterFn((function(  ) {
  return function(d) { return "14.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a337121048 = messageFormatterFn((function(  ) {
  return function(d) { return "14.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a337955196 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a338044569 = messageFormatterFn((function(  ) {
  return function(d) { return "15.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a338878717 = messageFormatterFn((function(  ) {
  return function(d) { return "16.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a338968090 = messageFormatterFn((function(  ) {
  return function(d) { return "16.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a339802238 = messageFormatterFn((function(  ) {
  return function(d) { return "17.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a339891611 = messageFormatterFn((function(  ) {
  return function(d) { return "17.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a340725759 = messageFormatterFn((function(  ) {
  return function(d) { return "18.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a340815132 = messageFormatterFn((function(  ) {
  return function(d) { return "18.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a341649280 = messageFormatterFn((function(  ) {
  return function(d) { return "19.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a341738653 = messageFormatterFn((function(  ) {
  return function(d) { return "19.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a361966742 = messageFormatterFn((function(  ) {
  return function(d) { return "20.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a362056115 = messageFormatterFn((function(  ) {
  return function(d) { return "20.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a362890263 = messageFormatterFn((function(  ) {
  return function(d) { return "21.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a362979636 = messageFormatterFn((function(  ) {
  return function(d) { return "21.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a363813784 = messageFormatterFn((function(  ) {
  return function(d) { return "22.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a363903157 = messageFormatterFn((function(  ) {
  return function(d) { return "22.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a364737305 = messageFormatterFn((function(  ) {
  return function(d) { return "23.00"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a364826678 = messageFormatterFn((function(  ) {
  return function(d) { return "23.30"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b467188455 = messageFormatterFn((function(  ) {
  return function(d) { return "Yalnızca doğrudan uçuşlar"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b448925420 = messageFormatterFn((function(  ) {
  return function(d) { return "Tercih edilen sınıf"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1481490220 = messageFormatterFn((function(  ) {
  return function(d) { return "Ekonomi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1689527373 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium ekonomi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2087569716 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a9972980 = messageFormatterFn((function(  ) {
  return function(d) { return "First class"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1064686027 = messageFormatterFn((function(  ) {
  return function(d) { return "Misafirler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a713043607 = messageFormatterFn((function(  ) {
  return function(d) { return "Kucaktaki her bebek için en az 1 misafir (6 yaşından büyük) olmalıdır."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1399076910 = messageFormatterFn((function(  ) {
  return function(d) { return "Bebekler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1976222299 = messageFormatterFn((function(  ) {
  return function(d) { return "(2-17 yaşında)"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1995786441 = messageFormatterFn((function(  ) {
  return function(d) { return "2 yaşından küçük"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b516575685 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". bebeğin yaşı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2028474047 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için bebek sayısını azaltın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a143266845 = messageFormatterFn((function(  ) {
  return function(d) { return "Oda " + d["0"] + " için bebek sayısını artırın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1212380497 = messageFormatterFn((function(  ) {
  return function(d) { return "2 yaşından küçük çocukların bir koltukta veya kucakta oturması gerekir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b863175913 = messageFormatterFn((function(  ) {
  return function(d) { return "Kucakta"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1536958229 = messageFormatterFn((function(  ) {
  return function(d) { return "Koltukta"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1423375084 = messageFormatterFn((function(  ) {
  return function(d) { return "Havayolu şirketi yaş kuralları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1221250912 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış noktası"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2071531880 = messageFormatterFn((function(  ) {
  return function(d) { return "Gidiş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2110434212 = messageFormatterFn((function(  ) {
  return function(d) { return "Dönüş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a564601154 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen başlangıç noktası seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a841020132 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatimizin yalnızca bir kısmı için konaklama yerlerine ihtiyacım var"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a624849827 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bizim tarafımızda bir sorun oluştu. Lütfen tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1797867985 = messageFormatterFn((function(  ) {
  return function(d) { return "Karşılaştırmak için en az 1 konaklama yeri daha seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1719795758 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " konaklama yeri";}, one: function() { return number(d["1"]) + " konaklama yeri";}, two: function() { return number(d["1"]) + " konaklama yeri";}, few: function() { return number(d["1"]) + " konaklama yeri";}, many: function() { return number(d["1"]) + " konaklama yeri";}, other: function() { return number(d["1"]) + " konaklama yeri";} }) + " seçili"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b617886326 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Karşılaştırma için " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " konaklama yeri";}, one: function() { return number(d["1"]) + " konaklama yeri";}, two: function() { return number(d["1"]) + " konaklama yeri";}, few: function() { return number(d["1"]) + " konaklama yeri";}, many: function() { return number(d["1"]) + " konaklama yeri";}, other: function() { return number(d["1"]) + " konaklama yeri";} }) + " seçili"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1899904536 = messageFormatterFn((function(  ) {
  return function(d) { return "Karşılaştır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a525699844 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçili konaklama yerlerini karşılaştır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1154201570 = messageFormatterFn((function(  ) {
  return function(d) { return "Karşılaştır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1177365314 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçili konaklama yerlerini karşılaştır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a396646320 = messageFormatterFn((function(  ) {
  return function(d) { return "Görüntüle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a892842092 = messageFormatterFn((function(  ) {
  return function(d) { return "Konaklama yerini görüntülemek için tıklayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1512826319 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaldır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b199287379 = messageFormatterFn((function(  ) {
  return function(d) { return "Konaklama yerini karşılaştırma işleminden kaldırmak için tıklayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b222679774 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a470919590 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal Et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1396553076 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a578360558 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a81271088 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaldır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1960419001 = messageFormatterFn((function(  ) {
  return function(d) { return "seçili"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1659240538 = messageFormatterFn((function(  ) {
  return function(d) { return "Yükleniyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b232438729 = messageFormatterFn((function(  ) {
  return function(d) { return "Temizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b697172145 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni bir pencerede açılır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a214056907 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha fazla göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1644147160 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b285143796 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha fazla göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1346358567 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1881578930 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " seçildi. Şimdi bir çıkış tarihi seçin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1074709985 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " seçildi. Şimdi bu tarihleri kaydetmek ve tarih seçicisini kapatmak için " + d["1"] + " seçeneğini belirleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2137215235 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", seçildi. Mevcut giriş tarihi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1723778050 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", seçildi. Mevcut çıkış tarihi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1109772972 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", tarih devre dışı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1709655535 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", şu anki ay"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1956746508 = messageFormatterFn((function(  ) {
  return function(d) { return "Şu anda " + d["0"] + " ve " + d["1"] + " gösteriliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1313422024 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarih seçicisi açıldı. Aşağıdaki tablolardan tarih seçin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1117667414 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal edin, değişiklikleri kaydetmeden tarih seçicisini kapatın. Veya aşağıdaki tablolardan tarih seçin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1553312198 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçili tarihleri temizleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1233378479 = messageFormatterFn((function(  ) {
  return function(d) { return "Değişiklikleri kaydedin ve tarih seçicisini kapatın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a417769130 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " gece";}, one: function() { return number(d["0"]) + " gece";}, two: function() { return number(d["0"]) + " gece";}, few: function() { return number(d["0"]) + " gece";}, many: function() { return number(d["0"]) + " gece";}, other: function() { return number(d["0"]) + " gece";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a26570234 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a799342475 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1697885228 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarihleri temizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1706110699 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1570016977 = messageFormatterFn((function(  ) {
  return function(d) { return "Ara"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a234089415 = messageFormatterFn((function(  ) {
  return function(d) { return "Aşağıdaki tablolarda giriş tarihini düzenleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a620247896 = messageFormatterFn((function(  ) {
  return function(d) { return "Aşağıdaki tablolarda çıkış tarihini düzenleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a174464025 = messageFormatterFn((function(  ) {
  return function(d) { return "seçildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b316480140 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " seçildi. Tarihi seçicisini kapatın veya devam ederek seçili tarihi değiştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1093066364 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-" + d["1"] + " arasındaki tarihler seçildi. Tarihi seçicisini kapatın veya devam ederek seçili tarihleri değiştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b887749950 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " seçildi. " + d["1"] + ". Tarihi seçicisini kapatın veya devam ederek seçili tarihi değiştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1858592842 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-" + d["1"] + " arasındaki tarihler seçildi. " + d["2"] + ". Tarihi seçicisini kapatın veya devam ederek seçili tarihleri değiştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b881120035 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1609843626 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış tarihi seçin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b923855803 = messageFormatterFn((function(  ) {
  return function(d) { return "boş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1937810147 = messageFormatterFn((function(  ) {
  return function(d) { return "Önceki ay"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b692016441 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelecek ay"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b966094104 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " düğmesine atla"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a431667392 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "-" + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1230441533 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarihler temizlendi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1316880464 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " sonuç var";}, one: function() { return number(d["0"]) + " sonuç var";}, two: function() { return number(d["0"]) + " sonuç var";}, few: function() { return number(d["0"]) + " sonuç var";}, many: function() { return number(d["0"]) + " sonuç var";}, other: function() { return number(d["0"]) + " sonuç var";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a651202727 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " sonuç";}, one: function() { return number(d["1"]) + " sonuç";}, two: function() { return number(d["1"]) + " sonuç";}, few: function() { return number(d["1"]) + " sonuç";}, many: function() { return number(d["1"]) + " sonuç";}, other: function() { return number(d["1"]) + " sonuç";} }) + " var. Listede gezinmek için ok tuşlarını kullanın veya listeyi kaydırın."; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b137724083 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " araması açık, arama terimi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1506126398 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " seçtiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a630312351 = messageFormatterFn((function(  ) {
  return function(d) { return "Menü kapatıldı."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1816605595 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " araması açık, şu anda " + d["2"] + " için " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " öneri";}, one: function() { return number(d["1"]) + " öneri";}, two: function() { return number(d["1"]) + " öneri";}, few: function() { return number(d["1"]) + " öneri";}, many: function() { return number(d["1"]) + " öneri";}, other: function() { return number(d["1"]) + " öneri";} }) + " gösteriliyor. Aşağıdaki listeye gidin."; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1759890226 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " araması açık, " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " öneri";}, one: function() { return number(d["1"]) + " öneri";}, two: function() { return number(d["1"]) + " öneri";}, few: function() { return number(d["1"]) + " öneri";}, many: function() { return number(d["1"]) + " öneri";}, other: function() { return number(d["1"]) + " öneri";} }) + " gösteriliyor. Arama terimini girin veya aşağıdaki listeye gidin."; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b841138798 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " araması açık, şu anda seçili olan " + d["1"] + ", " + d["3"] + " için " + plural(d["2"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["2"]) + " öneri";}, one: function() { return number(d["2"]) + " öneri";}, two: function() { return number(d["2"]) + " öneri";}, few: function() { return number(d["2"]) + " öneri";}, many: function() { return number(d["2"]) + " öneri";}, other: function() { return number(d["2"]) + " öneri";} }) + " gösteriyor. Aşağıdaki listeye gidin."; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1838370068 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1355415477 = messageFormatterFn((function(  ) {
  return function(d) { return "Tümünü Temizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1676982110 = messageFormatterFn((function(  ) {
  return function(d) { return "Seçili Öğeler"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2070981547 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " kaldırıldı."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2110242674 = messageFormatterFn((function(  ) {
  return function(d) { return "Tüm seçimler kaldırıldı."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b884773341 = messageFormatterFn((function(  ) {
  return function(d) { return "Metin girişi alanına girdiniz. Lütfen arama yapın veya aşağıdaki önerilen kategorilerden seçim yapın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a131031044 = messageFormatterFn((function(  ) {
  return function(d) { return "“" + d["0"] + "” için arama yapın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a834130627 = messageFormatterFn((function(  ) {
  return function(d) { return "“" + d["0"] + "” için sonuç yok"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1761157081 = messageFormatterFn((function(  ) {
  return function(d) { return "Havaalanı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2101618498 = messageFormatterFn((function(  ) {
  return function(d) { return "Otel"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1206078696 = messageFormatterFn((function(  ) {
  return function(d) { return "Görülecek Yer"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2002401281 = messageFormatterFn((function(  ) {
  return function(d) { return "Yakında"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1175248066 = messageFormatterFn((function(  ) {
  return function(d) { return "Şunu deneyin: “" + d["0"] + "”"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a151845095 = messageFormatterFn((function(  ) {
  return function(d) { return "Bölge/Şehir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1624216283 = messageFormatterFn((function(  ) {
  return function(d) { return "Havaalanı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1216275677 = messageFormatterFn((function(  ) {
  return function(d) { return "Görülecek Yer"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a726030222 = messageFormatterFn((function(  ) {
  return function(d) { return "Otel"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1240431090 = messageFormatterFn((function(  ) {
  return function(d) { return "Adres"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2021931080 = messageFormatterFn((function(  ) {
  return function(d) { return "Tren İstasyonu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b246456233 = messageFormatterFn((function(  ) {
  return function(d) { return "Metro İstasyonu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2081761467 = messageFormatterFn((function(  ) {
  return function(d) { return "Yakındaki yerleri keşfedin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b389470546 = messageFormatterFn((function(  ) {
  return function(d) { return "Son aramalar"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1166346924 = messageFormatterFn((function(  ) {
  return function(d) { return "İnsanlar ayrıca şunları da aradı:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b617159263 = messageFormatterFn((function(  ) {
  return function(d) { return "Popüler tatil noktalarını keşfet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1560524723 = messageFormatterFn((function(  ) {
  return function(d) { return "Popüler tatil noktaları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2016874263 = messageFormatterFn((function(  ) {
  return function(d) { return "En rağbet gören tatil noktaları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b439930261 = messageFormatterFn((function(  ) {
  return function(d) { return "Mevcut konum"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1960283160 = messageFormatterFn((function(  ) {
  return function(d) { return "Konum paylaşımı devre dışı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a632972136 = messageFormatterFn((function(  ) {
  return function(d) { return "Konumunuzu belirleyemiyoruz. Konumunuzu belirleyebilmemiz için lütfen cihazınızda Harita (Konum) Hizmetleri'ni açın veya bir tatil noktası girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a964469820 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " oda";}, one: function() { return number(d["0"]) + " oda";}, two: function() { return number(d["0"]) + " oda";}, few: function() { return number(d["0"]) + " oda";}, many: function() { return number(d["0"]) + " oda";}, other: function() { return number(d["0"]) + " oda";} }) + ", " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " misafir";}, one: function() { return number(d["1"]) + " misafir";}, two: function() { return number(d["1"]) + " misafir";}, few: function() { return number(d["1"]) + " misafir";}, many: function() { return number(d["1"]) + " misafir";}, other: function() { return number(d["1"]) + " misafir";} }); }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b413996790 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " alanının değeri şu an " + d["1"] + ". " + d["2"] + " alanının değeri artık " + d["3"] + "."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1333532167 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ve " + d["1"] + " alanlarındaki girişlerin yerlerini değiştir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b498813798 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b813155937 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi gizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1469139864 = messageFormatterFn((function(  ) {
  return function(d) { return "Şu anda " + d["0"] + " gösteriliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a577936893 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/" + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a610999257 = messageFormatterFn((function(  ) {
  return function(d) { return "Resim " + d["0"] + " / " + d["1"] + ". " + d["2"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a88311446 = messageFormatterFn((function(  ) {
  return function(d) { return "Sonraki resmi göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1278990482 = messageFormatterFn((function(  ) {
  return function(d) { return "Önceki resmi göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1785317496 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " resmi";}, one: function() { return number(d["0"]) + " resmi";}, two: function() { return number(d["0"]) + " resmi";}, few: function() { return number(d["0"]) + " resmin tamamını";}, many: function() { return number(d["0"]) + " resmin tamamını";}, other: function() { return number(d["0"]) + " resmin tamamını";} }) + " göster"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1779465491 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["1"] + " için " + plural(d["0"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["0"]) + " resmi";}, one: function() { return number(d["0"]) + " resmi";}, two: function() { return number(d["0"]) + " resmi";}, few: function() { return number(d["0"]) + " resmin tamamını";}, many: function() { return number(d["0"]) + " resmin tamamını";}, other: function() { return number(d["0"]) + " resmin tamamını";} }) + " göster"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a154592810 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamamlandı:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a576901848 = messageFormatterFn((function(  ) {
  return function(d) { return "Mevcut:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b561795578 = messageFormatterFn((function(  ) {
  return function(d) { return "Adım " + d["0"] + "/" + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a893312982 = messageFormatterFn((function(  ) {
  return function(d) { return "Adım " + d["0"] + "/" + d["1"] + ":"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a382579351 = messageFormatterFn((function(  ) {
  return function(d) { return "Resim " + d["0"] + " / " + d["1"] + ". " + d["2"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b533154604 = messageFormatterFn((function(  ) {
  return function(d) { return "Sonraki resim"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a810792912 = messageFormatterFn((function(  ) {
  return function(d) { return "Önceki resim"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2080965726 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", tam ekran görünümüne genişlet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2049811338 = messageFormatterFn((function(  ) {
  return function(d) { return "Öğe " + d["0"] + ", tam ekran görünümüne genişlet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1657603188 = messageFormatterFn((function(  ) {
  return function(d) { return "Şu anki sayfa"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b90373316 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha fazla içerik göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b128194432 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az içerik göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b178898781 = messageFormatterFn((function(  ) {
  return function(d) { return "Yüzde " + d["0"] + " yüklendi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1917946718 = messageFormatterFn((function(  ) {
  return function(d) { return "Yükleniyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2027593106 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a550371561 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir hata oluştu."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b782589683 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu videoyu www.youtube.com’da izlemeyi deneyin veya tarayıcınızda devre dışıysa Javascript’i etkinleştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1861865355 = messageFormatterFn((function(  ) {
  return function(d) { return "Videoyu oynat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1132466245 = messageFormatterFn((function(  ) {
  return function(d) { return "Videoyu duraklat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a590089501 = messageFormatterFn((function(  ) {
  return function(d) { return "Video yükleniyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b766237549 = messageFormatterFn((function(  ) {
  return function(d) { return "Fotosfer"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b456620365 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu, 360 derecelik bir görüntüdür. İçinde gezinmek için kontrol ve ok tuşlarını veya komut ve ok tuşlarını kullanın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b487902304 = messageFormatterFn((function(  ) {
  return function(d) { return "Şu anda görüntüleniyor: " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1509769409 = messageFormatterFn((function(  ) {
  return function(d) { return "Sola doğru hareket ediliyor. Pozisyon: " + d["0"] + " derece"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1587003066 = messageFormatterFn((function(  ) {
  return function(d) { return "Sağa doğru hareket ediliyor. Pozisyon: " + d["0"] + " derece"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1245631507 = messageFormatterFn((function(  ) {
  return function(d) { return "Yukarıya doğru hareket ediliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1729066726 = messageFormatterFn((function(  ) {
  return function(d) { return "Aşağıya doğru hareket ediliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1855860907 = messageFormatterFn((function(  ) {
  return function(d) { return "En üsttesiniz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a46793473 = messageFormatterFn((function(  ) {
  return function(d) { return "En alttasınız"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1453433173 = messageFormatterFn((function(  ) {
  return function(d) { return "Tüm satırları seç"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1830020788 = messageFormatterFn((function(  ) {
  return function(d) { return "Tüm satırların seçimini kaldır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1424130756 = messageFormatterFn((function(  ) {
  return function(d) { return "Sütunu azalan düzende sırala"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2092839454 = messageFormatterFn((function(  ) {
  return function(d) { return "Sütunu artan düzende sırala"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a400961842 = messageFormatterFn((function(  ) {
  return function(d) { return "Sütun şimdi azalan sırada görünüyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2084594486 = messageFormatterFn((function(  ) {
  return function(d) { return "Sütun şimdi artan sırada görünüyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b934686318 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ". satırı genişlet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1094590383 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " / " + plural(d["1"], 0, pluralFuncs["tr-TR"], { zero: function() { return number(d["1"]) + " öğe";}, one: function() { return number(d["1"]) + " öğe";}, two: function() { return number(d["1"]) + " öğe";}, few: function() { return number(d["1"]) + " öğe";}, many: function() { return number(d["1"]) + " öğe";}, other: function() { return number(d["1"]) + " öğe";} }) + " gösteriliyor"; }
})(messageFormat.number, messageFormat.plural, {"tr-TR": Globalize("tr-TR").pluralGenerator()}), Globalize("tr-TR").pluralGenerator({}));
Globalize.a948150655 = messageFormatterFn((function(  ) {
  return function(d) { return "şu an seçili aylarınız " + d["0"] + " " + d["1"] + " ve " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1067626791 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş tarihi temizlendi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1671527024 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış tarihi temizlendi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1550313585 = messageFormatterFn((function(  ) {
  return function(d) { return "Tarihler temizlendi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a903449837 = messageFormatterFn((function(  ) {
  return function(d) { return "Sonraki"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1358648365 = messageFormatterFn((function(  ) {
  return function(d) { return "Önceki"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a145512690 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş tarihiniz olarak " + d["0"] + " seçildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1131090345 = messageFormatterFn((function(  ) {
  return function(d) { return "Çıkış tarihiniz olarak " + d["0"] + " seçildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1674353650 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geçerli bir giriş tarihi değil."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a55642103 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " geçerli bir çıkış tarihi değil."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b437595174 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " müsait değil."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1012421109 = messageFormatterFn((function(  ) {
  return function(d) { return "Bugün"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1938459852 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/" + d["1"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b825985416 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1940531784 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b79245301 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1201699259 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1886390760 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1625542131 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b88668744 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1832249736 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1302755464 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b320816693 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1690156568 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b968257817 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"P","mon":"P","tue":"S","wed":"Ç","thu":"P","fri":"C","sat":"C"}}}});
Globalize.a107282360 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Pazar","mon":"Pazartesi","tue":"Salı","wed":"Çarşamba","thu":"Perşembe","fri":"Cuma","sat":"Cumartesi"}}}});
Globalize.b1145963080 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b840768984 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b49579221 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"2":Globalize("tr-TR").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1764992950 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"Oca","2":"Şub","3":"Mar","4":"Nis","5":"May","6":"Haz","7":"Tem","8":"Ağu","9":"Eyl","10":"Eki","11":"Kas","12":"Ara"}}}});
Globalize.b1139154541 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.a1102968706 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b1765596322 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b1764911129 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Oca","2":"Şub","3":"Mar","4":"Nis","5":"May","6":"Haz","7":"Tem","8":"Ağu","9":"Eyl","10":"Eki","11":"Kas","12":"Ara"}}}});
Globalize.a428799222 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM EEEE","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}},"days":{"E":{"4":{"sun":"Pazar","mon":"Pazartesi","tue":"Salı","wed":"Çarşamba","thu":"Perşembe","fri":"Cuma","sat":"Cumartesi"}}}});
Globalize.b1146542709 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM E","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}},"days":{"E":{"1":{"sun":"Paz","mon":"Pzt","tue":"Sal","wed":"Çar","thu":"Per","fri":"Cum","sat":"Cmt"}}}});
Globalize.b447271665 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1561818033 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1735671906 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a613217948 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1507677009 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a189375076 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a290045007 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1453535985 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b924041713 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1494100514 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a2068870319 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1119431184 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b728878193 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1982123633 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b257485391 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d"}));
Globalize.b440986302 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b2102115777 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b760440790 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b41806901 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1386882571 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1386197378 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b188931329 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b767828958 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1166790078 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a52243710 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a946290897 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b176163061 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a106384734 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b600005933 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1904106750 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a160525758 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a690020030 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a704719505 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b612035234 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a686703585 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^P/],["mon",/^P/],["tue",/^S/],["wed",/^Ç/],["thu",/^P/],["fri",/^C/],["sat",/^C/]]});
Globalize.b1640447106 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["mon",/^Pazartesi/],["sat",/^Cumartesi/],["wed",/^Çarşamba/],["thu",/^Perşembe/],["sun",/^Pazar/],["tue",/^Salı/],["fri",/^Cuma/]]});
Globalize.a1401274750 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.b1815272414 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b285383311 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b803123280 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Oca/],["2",/^Şub/],["3",/^Mar/],["4",/^Nis/],["5",/^May/],["6",/^Haz/],["7",/^Tem/],["8",/^Ağu/],["9",/^Eyl/],["10",/^Eki/],["11",/^Kas/],["12",/^Ara/]]});
Globalize.a853620953 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.b1545500420 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.a227179172 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.a227864365 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Oca/],["2",/^Şub/],["3",/^Mar/],["4",/^Nis/],["5",/^May/],["6",/^Haz/],["7",/^Tem/],["8",/^Ağu/],["9",/^Eyl/],["10",/^Eki/],["11",/^Kas/],["12",/^Ara/]]});
Globalize.b2129391632 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM EEEE","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]],"gregorian/days/format/wide":[["mon",/^Pazartesi/],["sat",/^Cumartesi/],["wed",/^Çarşamba/],["thu",/^Perşembe/],["sun",/^Pazar/],["tue",/^Salı/],["fri",/^Cuma/]]});
Globalize.a846232785 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM E","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]],"gregorian/days/format/abbreviated":[["sun",/^Paz/],["mon",/^Pzt/],["tue",/^Sal/],["wed",/^Çar/],["thu",/^Per/],["fri",/^Cum/],["sat",/^Cmt/]]});
module.exports = Globalize;
